export default __webpack_public_path__ + "static/media/img-0669-albania-full-face.438ea3b8.png";